import { useTable } from "react-table";
import { useMemo, useState } from "react";
import primaryComponents from "../../primaryComponents";
import secondaryComponents from "..";
import { DeleteIcon } from "../../../assets/svgIcons";
import { useGetChartAccountDetails } from "../../../hooks/api/queries";
import { Link } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";

const useAccountsListLogic = ({ accounts, handleFetchAccountsList }) => {
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [selectedChartAccount, setSelectedChartAccount] = useState(null);
  const [selectedDeleteAccount, setSelectedDeleteAccount] = useState(null);

  const { isLoading: isFetchingBankInfo, data: bankInfo } =
    useGetChartAccountDetails(
      selectedBankAccount || selectedChartAccount || selectedDeleteAccount,
    );
  const columns = useMemo(
    () => [
      {
        Header: "Account Code",
        accessor: "account_code",
        Cell: ({ cell: { value, row } }) => (
          <Link
            className="purple--text"
            to={pathConstants.ACCOUNTING_CHART_ACCOUNT_DETAILS({
              account_id: row?.original["id"],
            })}
            style={{
              fontSize: "12px",
            }}
          >
            {value}
          </Link>
        ),
      },
      {
        Header: "Account Name",
        accessor: "account_name",
        Cell: ({ cell: { value, row } }) =>
          value ? (
            <span style={{ color: "#7647ee" }}>
              {value}
              <br></br>
              <span
                className="small"
                style={{ color: "#222", fontWeight: "500" }}
              >
                {row?.original?.supplier?.name}
              </span>
            </span>
          ) : (
            "N/A"
          ),
      },
      {
        Header: "Type",
        accessor: "account_type_label",
        Cell: ({ cell: { value, row } }) =>
          value ? (
            <span style={{ color: "#7647ee" }}>
              {value}
              <br></br>
              <span
                className="small"
                style={{ color: "#222", fontWeight: "500" }}
              >
                {row?.original?.sub_account_type_label}
              </span>
            </span>
          ) : (
            "N/A"
          ),
      },
      {
        Header: "Active?",
        accessor: "active",
        Cell: ({ cell: { value } }) =>
          value ? (
            <span className="text-success">Yes</span>
          ) : (
            <span className="text-danger">No</span>
          ),
      },
      {
        Header: "Bank Name",
        accessor: "bank_name",
        Cell: ({ cell: { value } }) => (value ? value : "-"),
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ cell: { row } }) => (
          <div className="d-flex" style={{ gap: "5px" }}>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Accounting"}
              permissionChildKey="can_update_ledger_account"
            >
              <primaryComponents.Button
                classNames={"btn btn--primary smallBtn"}
                isDisabled={!row?.original}
                onClick={() => {
                  if (
                    row?.original?.id &&
                    row?.original?.is_bank_account === true
                  ) {
                    setSelectedBankAccount(row?.original?.id);
                  }
                  if (
                    row?.original?.id &&
                    row?.original?.is_bank_account === false
                  ) {
                    setSelectedChartAccount(row?.original?.id);
                  }
                }}
              >
                Update
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Accounting"}
              permissionChildKey="can_delete_ledger_account"
            >
              <primaryComponents.Button
                classNames={"btn btn--outline-red smallBtn"}
                onClick={() => {
                  if (row?.original?.id) {
                    setSelectedDeleteAccount(row?.original?.id);
                  }
                }}
              >
                <DeleteIcon type="menu" />
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>
        ),
      },
    ],
    [selectedBankAccount, selectedChartAccount, handleFetchAccountsList],
  );

  const instance = useTable({ columns, data: accounts });
  return {
    instance,
    selectedBankAccount,
    selectedChartAccount,
    selectedDeleteAccount,
    setSelectedDeleteAccount,
    setSelectedBankAccount,
    setSelectedChartAccount,
    bankInfo,
    isFetchingBankInfo,
  };
};

export default useAccountsListLogic;
